import { render, staticRenderFns } from "./projektmanagement-4-3.vue?vue&type=template&id=e58a9166&"
import script from "./projektmanagement-4-3.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-4-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports